<div class="surface-card p-3 border-round shadow-2 flex align-items-center gap-3 h-full">
  <div
    class="flex align-items-center justify-content-center border-circle flex-shrink-0"
    [ngClass]="iconBg"
    style="width: 3rem; height: 3rem"
  >
    <i class="text-xl" [class]="icon" [ngClass]="iconColor"></i>
  </div>
  <div>
    <div class="text-600 text-sm mb-1">{{ label }}</div>
    <div class="text-900 font-bold text-2xl">
      <ng-container *ngIf="!loading; else skeleton">
        {{ value ?? '—' }}{{ suffix ? ' ' + suffix : '' }}
      </ng-container>
    </div>
  </div>
  <ng-content></ng-content>
</div>

<ng-template #skeleton>
  <p-skeleton width="3.5rem" height="1.75rem" borderRadius="6px"></p-skeleton>
</ng-template>
